import "./Livelineup.css";
import { NavLink } from "react-router-dom";

const Livelineup = ({ lineups = [], events = [], myhome = [], myaway = [], dark, slug, HomeTeam, AwayTeam }) => {

  if (!Array.isArray(lineups) || lineups.length < 2) {
    return (
      <div
        className="lineupWrapper"
        style={{ display: "flex", flexDirection: "column", color: dark ? "#e0e0e0ff" : "#23262D", alignItems: "center", justifyContent: "center", height: "300px" }}
      >
        No lineup available
      </div>
    );
  }

  const home = lineups[0];
  const away = lineups[1];

  const getPlayerEvents = (playerId) => {
    const ev = events?.filter(e => e?.player?.id === playerId) || [];

    return {
      yellow: ev.find(e => e?.detail === "Yellow Card"),
      red: ev.find(e => e?.detail === "Red Card"),
      goal: ev.find(e => e?.type === "Goal")
    };
  };

  const renderPlayers = (players = [], side) => {

    if (!Array.isArray(players)) return null;

    const rows = {};
    players.forEach(p => {
      const grid = p?.player?.grid || "0:0";
      const [r] = grid.split(":");
      if (!rows[r]) rows[r] = [];
      rows[r].push(p);
    });

    const sortedRows = Object.keys(rows)
      .map(Number)
      .sort((a, b) => a - b);

    const totalRows = sortedRows.length;

    return sortedRows.flatMap((row, rowIndex) => {

      const rowPlayers = rows[row];

      return rowPlayers.map((p, colIndex) => {

        const player = p?.player || {};

        const verticalBase = ((rowIndex + 1) / (totalRows + 1)) * 50;

        const vertical =
          side === "home"
            ? verticalBase + 3
            : 100 - verticalBase;

        const horizontal =
          ((colIndex + 1) / (rowPlayers.length + 1)) * 100;

        const ev = getPlayerEvents(player?.id);

        return (
          <NavLink
            to={`/players/${player.name
              ?.trim()
              .replace(/[^a-zA-Z.\s]/g, "")
              .replace(/\s+/g, "-")
              .toLowerCase()
            }-${player.id}`}
            state={{ player, leagueSlug: slug }}
            key={player.id}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className={`player ${side}`}
              style={{
                top: `${vertical}%`,
                left: `${horizontal}%`
              }}
            >
              {ev.goal && <span className="goalIcon">⚽</span>}
              {ev.yellow && <span className="yellowCard"></span>}
              {ev.red && <span className="redCard"></span>}

              <div className="playerCircle">
                {player?.number}
              </div>

              <div className="playerName">
                {player?.name}
              </div>
            </div>
          </NavLink>
        );
      });
    });
  };

  const renderSubstitutes = (subs = []) => {
    if (!Array.isArray(subs)) return null;

    return subs.map((s, i) => {

      const player = s?.player || {};

      return (
        <NavLink
          to={`/players/${player.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
          }-${player.id}`}
          state={{ player, leagueSlug: slug }}
          key={player.id || i}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="subPlayer">
            {subs === home?.substitutes ? (

              <p>
                <span
                  className="subNumber"
                  style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
                >
                  {player?.number}
                </span>
                <span
                  className="subName"
                  style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
                >
                  {player?.name}
                </span>
              </p>

            ) : (
              <p className="aways">
                <span
                  className="subName"
                  style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
                >
                  {player?.name}
                </span>
                <span
                  className="subNumber"
                  style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
                >
                  {player?.number}
                </span>
              </p>
            )}
          </div>
        </NavLink>
      );
    });
  };

  const homeCoach = home?.coach
    ? { ...home.coach, id: home.coach?.id || `coach-home`, name: home.coach?.name }
    : null;

  const awayCoach = away?.coach
    ? { ...away.coach, id: away.coach?.id || `coach-away`, name: away.coach?.name }
    : null;

  return (
    <div className="lineupWrapper">
      <div className="pitch">

        <nav>
          <NavLink to={`/teams/${HomeTeam}`} >
            <span style={{color: "whitesmoke"}}> 
              <img src={myhome?.logo} alt="" />
              <h2>{myhome?.name}</h2>
            </span>
          </NavLink>
          <span style={{color: "whitesmoke"}}>
            {home?.formation}
          </span>
        </nav>

        <div className="centerLine"></div>
        <div className="centerCircle"></div>

        <div className="box18 top"></div>
        <div className="box6 top"></div>
        <div className="arc top"></div>

        <div className="box18 bottom"></div>
        <div className="box6 bottom"></div>
        <div className="arc bottom"></div>

        {renderPlayers(home?.startXI, "home")}
        {renderPlayers(away?.startXI, "away")}

        <nav className="myAway">
          
          <NavLink to={`/teams/${AwayTeam}`} >
            <span style={{color: "whitesmoke"}}>
              <img src={myaway?.logo} alt="" />
              <h2>{myaway?.name}</h2>
            </span>
          </NavLink>
          <span style={{color: "whitesmoke"}}>
            {away.formation}
          </span>
        </nav>
      </div>

      <section
        className="substitutes"
        style={dark ? { backgroundColor: "#333333ff" } : { backgroundColor: "white" }}
      >
        <span>
          <nav>
            <img src={myhome?.logo} alt="" />
            <h2 style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}>
              {myhome?.name}
            </h2>
          </nav>

          <p style={dark ? { color: "#e0e0e0ff" } : { color: "#2D2F36" }}>
            Substitutes
          </p>

          <nav className="myAway">
            <h2 style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}>
              {myaway?.name}
            </h2>
            <img src={myaway?.logo} alt="" />
          </nav>
        </span>

        <div className="subsTeam">
          <div>
            {renderSubstitutes(home?.substitutes)}
          </div>
          <div>
            {renderSubstitutes(away?.substitutes)}
          </div>
        </div>
      </section>

      <section
        className="coachesSection"
        style={dark ? { backgroundColor: "#333333ff" } : { backgroundColor: "white" }}
      >

        <h3 style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}>
          Coaches
        </h3>

        <div className="coachesWrapper">

        {homeCoach && (
        <NavLink
          to={`/players/${homeCoach.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
          }-${homeCoach.id}`}
          state={{ player: homeCoach, leagueSlug: slug }}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="coachCard">
            <img src={home?.coach?.photo} alt="" />
            <p
              className="coachName"
              style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
            >
              {home?.coach?.name}
            </p>
            <span
              className="coachTeam"
              style={dark ? { color: "#bdbdbd" } : { color: "#555" }}
            >
              {myhome?.name}
            </span>
          </div>
         </NavLink> 
        )}

        {awayCoach && (
        <NavLink
          to={`/players/${awayCoach.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
          }-${awayCoach.id}`}
          state={{ player: awayCoach, leagueSlug: slug }}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="coachCard">
            <img src={away?.coach?.photo} alt="" />
            <p
              className="coachName"
              style={dark ? { color: "#e0e0e0ff" } : { color: "#23262D" }}
            >
              {away?.coach?.name}
            </p>
            <span
              className="coachTeam"
              style={dark ? { color: "#bdbdbd" } : { color: "#555" }}
            >
              {myaway?.name}
            </span>
          </div>
        </NavLink>
        )}

        </div>

      </section>

    </div>
  );
};

export default Livelineup;